export default function stripDashesFromGuid(guid) {
  return guid.replace(/-/g, '');
}